export default __webpack_public_path__ + "static/media/la_capelle14.7ce986f0.jpg";